import { Component, ViewChild } from '@angular/core';
import { AppToastComponent as ToastComp } from '../../services/shared-service/toast-simple/toast.component';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from '../../services/http-service/http.service';
import { LocalInterfaceService } from '../../services/local-inteface-service/local-interface.service';
import { ValidationService } from '../../services/validation-service/validation.service';
import { StorageService } from '../../services/storege-service/storage.service';
import { concatenateStrings, getChannelColor, roundTo } from '../../../utils/utils';
import { ToolService } from '../../services/tool/tool.service';

@Component({
  selector: 'app-new-reports',
  templateUrl: './new-reports.component.html',
  styleUrls: ["../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css"],
})
export class NewReportsComponent {
  startDate = moment().startOf('month').format('YYYY-MM-DD');
  // startDate = moment().subtract(15, 'years').startOf('month').format('YYYY-MM-DD');

  endDate = moment().format('YYYY-MM-DD');
  isLoading = false;
  reportList?;
  reportDetails?;
  facilityId;
  selectedReport = "";
  facilityCCY=''

  reportHeader = {
    PAYMENTS: {
      detailsHeader: [
        'Booking ID',
        'Name',
        'Mobile',
        'Court',
        'Duration',
        'Price',
        'Start Time',
        'End Time',
        'Channel',
        'Payment Method',
        'Payment Date',
        'Commission Rate',
        'Fixed Amount'
      ],
      summaryHeader: [
        'Facility Name',
        'Count Payments',
        'Fixed Amount',
        'IBAN',
        'Rate',
        'Subscription Fee',
        'Total Amount',
        'Total Fee',
        'Total Services',
        'VAT',
        'To Pay',
      ]
    },
    WALLET_MANUAL_PAYMENTS: {
      detailsHeader: [
        'Name',
        'Mobile',
        'Amount',
        'Channel',
        'Payment Method',
        'Payment Date',
        'Commission Rate',
        'Fixed Amount'
      ],
      summaryHeader: [
        'From Date',
        'To Date',
        'Total Count',
        'Payment Method',
        'Total Amount',
        'Fixed Amount',
        'Commission',
        // 'Rate',
        'To Pay',
      ]
    },
    COACH_BOOKINGS: {
      detailsHeader: [
        'Coach Name',
        'Customer Name',
        'Customer Mobile',
        'Start Time',
        'End Time',
        'Total Amount',
        'Total Hours',
        'Total Minutes',
        'From Date',
        'To Date',
      ],
      summaryHeader: [
        'Coach Name',
        'Total Amount',
        'Total Count',
        'Total Hours',
        'Total Minutes',
        'From Date',
        'To Date',
      ]
    },
    TOURNAMENTS: {
      detailsHeader: [
        'Tournament ID',
        'Tournament Name',
        'Name',
        'Mobile',
        'Payment Method',
        'Amount',
        'Rate',
        'Paid Date',
        'Invoice ID',
      ],
      summaryHeader: [
        'Tournament Name',
        'Amount',
        'Rate',
        
      ]
    }
  };

  public roundTo = roundTo;
  public getChannelColor = getChannelColor;

  @ViewChild(ToastComp) toastComp: ToastComp;

  constructor(
    private router: Router,
    private http: HttpClient,
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private validationSrv: ValidationService,
    private storageSrv: StorageService,
    public toolService: ToolService,
  ) {
    this.facilityCCY=storageSrv.getFacilityCcy()
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess().then(async () => {
      this.facilityId = this.storageSrv.getFacilityId();
      this.isLoading = true
      await this.loadReportTypes();
      await this.loadDashboardReport();
    });
  }

  public goToDate = async (event) => {
    this[event.target.name] = event.target.value;

    if (moment(this.endDate).isBefore(this.startDate)) {
      this.toastr.error("'Invalid date selection: End Date is before Start Date'", "Error");
      return;
    }
    await this.loadDashboardReport();
  };

  public loadReportTypes = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getReportTypes(this.facilityId)
        .then(res => {
          this.reportList = res.content;
          this.selectedReport = res.content[0].reportCode;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err);
          this.toastr.error(err.desc, "Error");
          this.isLoading=false
        })
    });
  };

  public loadDashboardReport = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getDashboardReportDetails(this.facilityId, this.selectedReport, this.startDate, this.endDate)
        .then(res => {
          this.reportDetails = res;
          this.toolService.showConsoleLog('res.', this.reportDetails?.content?.detail);
          this.isLoading = false;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err);
          this.toastr.error(err.desc, "Error");
          this.isLoading = false;

        })

    });
  };

  onReportChange = async (event: any) => {
    this.selectedReport = event.target.value;
    await this.loadDashboardReport();
  };

  exportToCSV() {
    const csvContentSummary = this.convertToCSVSummary();
    const csvContentDetails = this.convertToCSVDetails();

    const mergedCSV = this.mergeCSVs([csvContentSummary, csvContentDetails]);
    const blob = new Blob([mergedCSV], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${this.startDate}-to-${this.endDate}.csv`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  convertToCSVSummary(): string {
    const summaryHeader = this.reportHeader[this.selectedReport].summaryHeader.join(',');
    let summaryRows = [];
    if (this.selectedReport === "PAYMENTS") {
      summaryRows = this.reportDetails?.content?.summary.map((row) => {

        

        return concatenateStrings(
        row.facilityName,
        row.countPayments,
        this.facilityCCY + " " + row.fixedAmount,
        row.iban,
        row.rate,
        this.facilityCCY + " " + row.subscriptionFee,
        this.facilityCCY + " " + this.roundTo(row.totalAmount,3),
        this.facilityCCY + " " + this.roundTo(row.totalFee,3),
        this.facilityCCY + " " + this.roundTo(row.totalServices,3),
        this.facilityCCY + " " + row.vat,
        this.facilityCCY + " " + this.roundTo(row.toPay,3),
        );
      });
    } else if (this.selectedReport === "COACH_BOOKINGS") {
      summaryRows = this.reportDetails?.content?.summary.map((row) => {
        return concatenateStrings(
          row.coachName,
          row.totalAmount,
          row.totalCount,
          row.totalHours,
          row.totalMinutes,
          row.fromDate,
          row.toDate,
        );
      });
    } else if (this.selectedReport === "WALLET_MANUAL_PAYMENTS") {
      summaryRows = this.reportDetails?.content?.summary.map((row) => {
        return concatenateStrings(
          row.fromDate,
          row.toDate,
          row.totalCount,
          row.paymentMethodCode,
          this.facilityCCY + " " + this.roundTo(row.totalAmount,3),
          this.facilityCCY + " " + this.roundTo(row.fixedAmount,3),
          row.commotion,
          // row.rate,
          this.facilityCCY + " " + this.roundTo(row.toPay,3),

        );
      });
    }
    else if (this.selectedReport === "TOURNAMENTS") {
      summaryRows = this.reportDetails?.content?.summary.map((row) => {
        return concatenateStrings(
          row.tournamentName.replace('\n'," "),
          row.ccy + " " + this.roundTo(row.amount,3),
          row.rate,
        );
      });
    }
    return `${'Summary'}\n${summaryHeader}\n${summaryRows.join('\n')}`;
  }

  convertToCSVDetails(): string {
    const detailHeader = this.reportHeader[this.selectedReport].detailsHeader.join(',');
    let detailRows = [];
    if (this.selectedReport === "PAYMENTS") {
      detailRows = this.reportDetails?.content?.detail.map((row) => {
        return concatenateStrings(
          row.bookingId,
          row.customerName,
          row.customerMobile,
          row.court,
          row.duration + "mins",
          this.facilityCCY + " " + row.amount,
          row.startTime,
          row.endTime,
          row?.channel,
          row.paymentMethodCode,
          row.paymentDate,
          row.arenaCommetionRate,
          this.facilityCCY + " " + row.arenaFixedAmount,
        );
      });
    } else if (this.selectedReport === "COACH_BOOKINGS") {
      detailRows = this.reportDetails?.content?.detail.map((row) => {
        return concatenateStrings(
          row.coachName,
          row.customerName,
          row.customerMobile,
          row.startTime,
          row.endTime,
          row.totalAmount,
          row.totalHours,
          row.totalMinutes,
          row.fromDate,
          row.toDate,
        );
      });
    } else if (this.selectedReport === "WALLET_MANUAL_PAYMENTS") {
      detailRows = this.reportDetails?.content?.detail.map((row) => {
        return concatenateStrings(
          row.customerName,
          row.customerMobile,
          row.ccy + " " + row.amount,
          row?.channel,
          row.paymentMethodCode,
          
          row.paymentDate,
          
          row.arenaCommetionRate,
          row.ccy + " " + row.arenaFixedAmount,
        );
      });
    }

    else if (this.selectedReport === "TOURNAMENTS") {
      detailRows = this.reportDetails?.content?.detail.map((row) => {
        return concatenateStrings(
          row.id,
          row.tournamentName.replace('\n'," "),
          row.name,
          row.country_code + " " + row.mobile,
          row.paymentMethodCode,
          row.ccy + " " + row.amount,
          row.rate,
          row.paidDate,
          row.invoiceId,
        );
      });
    }

    return `\n${'Details'}\n${detailHeader}\n${detailRows.join('\n')}`;
  }

  mergeCSVs(csvArray: string[]): string {
    return csvArray.join('\n\n');
  }
}
